import { Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import { ScreenState } from './ScreenState';
import { useLanguage } from '../../../../../_CORE/Contexts/Translate/useLanguageContext';
import { APP_ENVIRONMENT } from "../../../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppEnvironment.js";

const BLOCK = 'LStudio__app_screen';

/*
    🔥 403 — SIN PERMISO

    ⚠️ NO ES UN 404 DISFRAZADO

    Decirle "no existe" a algo que sí existe deja al usuario buscando
    un error propio que no cometió. Acá el mensaje es explícito y
    ofrece la única salida útil: pedirle el permiso a alguien.

    ⚠️ requiredPermission se muestra SOLO en desarrollo. Al usuario
       final no le sirve leer "vault.accounts.read", y al equipo de
       soporte le ahorra media hora.
*/

export const ScreenForbidden = ({
    title = null,
    description = null,
    requiredPermission = null,
    isDetailed = APP_ENVIRONMENT.RUNTIME.IS_DEVELOPMENT,
    backPath = '/',
    backLabel = null,
    actions = null,
    isFullScreen = false,
}) => {

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.screen ?? {};
    const COMMON = useDataLanguage.translations?.TEMPLATES?.common ?? {};

    return (
        <ScreenState
            icon={<FaLock />}
            code="403"
            tone="warn"
            title={title ?? TEXT.forbiddenTitle}
            description={description ?? TEXT.forbiddenText}
            isFullScreen={isFullScreen}
            actions={
                actions ?? (
                    <Link className={`${BLOCK}__button`} to={backPath}>{backLabel ?? COMMON.back}</Link>
                )
            }
        >
            {
                isDetailed && requiredPermission && (
                    <code className={`${BLOCK}__detail`}>
                        {TEXT.requiredPermission}: {requiredPermission}
                    </code>
                )
            }
        </ScreenState>
    );
};
